import React, { useMemo } from 'react'

import { useTheme } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { CheckCircle, Minus } from '@phosphor-icons/react'
import { Button, Column, Row, Text } from 'Components/UI'

import { MEMBERSHIP_PACKAGE_KIND } from 'Constants/MembershipPackages'

import {
  MembershipFeatureRecordFieldsFragment,
  MembershipPackageRecordFieldsFragment,
} from 'GraphQL/DatoCMS/TypedDocuments'

import { Card, Container, Divider, Price } from './styles'

function isPartnerPackage(kind?: string) {
  return (
    kind === MEMBERSHIP_PACKAGE_KIND.BLACK_PARTNER ||
    kind === MEMBERSHIP_PACKAGE_KIND.DIAMOND_PARTNER
  )
}

function getCellContent(
  membershipPackage: MembershipPackageRecordFieldsFragment,
  featureId: string,
  accentColor: string,
) {
  const entry = membershipPackage.featureEntries.find(
    featureEntry => featureEntry.feature?.id === featureId,
  )

  if (!entry?.isIncluded) return <Minus size={20} weight="bold" />

  if (entry.description) {
    return (
      <Text body regular screen14>
        {entry.description}
      </Text>
    )
  }

  return <CheckCircle color={accentColor} size={20} weight="fill" />
}

type Props = {
  item: MembershipPackageRecordFieldsFragment
  features: MembershipFeatureRecordFieldsFragment[]
  onAction?: () => void
}

function TeeOffCorporateMembershipPackagesSlide({
  item,
  features,
  onAction,
}: Props) {
  const theme = useTheme()

  const accentColor = useMemo(() => {
    return themeGet('colors.primary.main')({ theme })
  }, [theme])

  return (
    <Container>
      <Card tertiary={isPartnerPackage(item.kind)}>
        <Text bold center inverse preWrap screen24>
          {item.title}
        </Text>

        <Button large onClick={onAction}>
          Enquire Now
        </Button>
      </Card>

      <Text accent center medium mt={12} screen24>
        Features
      </Text>

      <Divider my={4} />

      {features.map(feature => (
        <Column fullWidth key={feature.id}>
          <Row justifyCenter mb={1}>
            {getCellContent(item, feature.id, accentColor)}
          </Row>

          <Text center important medium screen14>
            {feature.title}
          </Text>

          <Divider my={4} secondary />
        </Column>
      ))}

      <Price
        mt={5}
        secondary={item.kind === MEMBERSHIP_PACKAGE_KIND.CLUB_PLATINUM}
        tertiary={isPartnerPackage(item.kind)}
      >
        {item.isPriceUponApplication ? (
          <Text bold center inverse screen18>
            Upon Application
          </Text>
        ) : (
          <>
            <Text bold inverse screen18>
              ${item.price}
            </Text>

            <Text inverse regular screen18>
              +GST P/A
            </Text>
          </>
        )}
      </Price>
    </Container>
  )
}

export default TeeOffCorporateMembershipPackagesSlide
